<template>
  <el-form :model="ruleForm">
    <el-row :gutter="10">
      <el-col :xs="12" :sm="8" :md="6" :lg="4" :xl="3">
        <el-form-item label="Utiliza Malha" prop="malha">
          <el-switch v-model="ruleForm.malha"></el-switch>
        </el-form-item>
      </el-col>
      <el-col v-if="ruleForm.malha" :xs="12" :sm="8" :md="6" :lg="4" :xl="3">
        <el-form-item label="Utilizar todas as unidades" prop="malha_all_units">
          <el-switch
            v-model="ruleForm.malha_all_units"
            @change="allUnitsChanged"
          ></el-switch>
        </el-form-item>
      </el-col>
      <el-col v-if="ruleForm.malha" :xs="24" :sm="12" :md="8" :lg="6" :xl="5">
        <el-form-item prop="send_all">
          <span slot="label">
            Enviar todas as etiquetas para a malha
            <el-tooltip placement="top">
              <div slot="content">
                Toda etiqueta do cliente é enviada ao sistema de malha (Omni), mesmo sem rota ou unidade.<br />
                Não altera preço, desconto nem a troca de serviço.
              </div>
              <i class="el-icon-info customer-malha__info"></i>
            </el-tooltip>
          </span>
          <el-switch v-model="ruleForm.send_all"></el-switch>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="8" :md="6" :lg="4" :xl="3">
        <el-form-item label="Desconto Malha" prop="malha">
          <el-input v-model="ruleForm.discount_malha" type="number"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item v-if="showUnitsTable" prop="units">
      <span slot="label">
        Unidades permitidas
        <el-tooltip placement="top">
          <div slot="content">
            A seleção vale para origem e destino.<br />
            A malha só acontece entre unidades permitidas que tenham rota cadastrada (origem → destino).<br />
            Unidades sem rota ativa não entram na malha e ficam desabilitadas.
          </div>
          <i class="el-icon-info customer-malha__info"></i>
        </el-tooltip>
      </span>
      <el-table
        :data="unitList"
        stripe
        size="mini"
        ref="tableUnits"
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
        @selection-change="onUnitSelectionChange"
      >
        <el-table-column type="selection" width="55" :selectable="isRoutable"></el-table-column>
        <el-table-column sortable prop="code" width="120" :label="$t('codigo')"></el-table-column>
        <el-table-column
          sortable
          prop="name"
          :label="$t('nome')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="sourceRootStart"
          :label="$t('faixa')"
          width="220"
        >
          <template slot-scope="scope">{{ unitRange(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="Envia para" min-width="160">
          <template slot-scope="scope">
            <span v-if="destinationsOf(scope.row).length">{{ destinationsOf(scope.row).join(", ") }}</span>
            <span v-else class="customer-malha__muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="Recebe de" min-width="160">
          <template slot-scope="scope">
            <span v-if="originsOf(scope.row).length">{{ originsOf(scope.row).join(", ") }}</span>
            <span v-else class="customer-malha__muted">—</span>
          </template>
        </el-table-column>
      </el-table>
    </el-form-item>
    <!-- Prévia: rotas ativas que ficam habilitadas para o cliente com a seleção atual -->
    <div v-if="ruleForm.malha" class="customer-malha__preview">
      <span class="customer-malha__preview-title">Rotas de malha habilitadas para este cliente</span>
      <template v-if="enabledRoutes.length > 0">
        <el-tag
          v-for="route in enabledRoutes"
          :key="route.id"
          size="mini"
          type="info"
          disable-transitions
          class="customer-malha__route"
          :title="`${route.sourceName} → ${route.destinyName}`"
          >{{ route.sourceCode }} → {{ route.destinyCode }}</el-tag
        >
      </template>
      <span v-else class="customer-malha__muted">
        {{ ruleForm.malha_all_units ? "Nenhuma rota de malha ativa cadastrada nas unidades." : "Nenhuma rota de malha entre as unidades selecionadas." }}
      </span>
    </div>
    <el-divider content-position="left">Declaração de conteúdo padrão</el-divider>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="18">
        <el-form-item label="Conteudo" prop="content">
          <el-input ref="day" v-model="ruleForm.content"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="12" :sm="12" :md="6" :lg="4" :xl="3">
        <el-form-item label="Quantidade" prop="quantity">
          <el-input v-model="ruleForm.quantity" type="number"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="12" :sm="12" :md="6" :lg="4" :xl="3">
        <el-form-item label="Valor" prop="value">
          <el-input v-model="ruleForm.value" type="number"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import { UnitService } from "@/services/users/unit.services";

export default {
  name: "CustomerMalha",
  data() {
    return {
      ruleForm: {
        malha: false,
        malha_all_units: true,
        send_all: false,
        units: [],
        content: "",
        quantity: 1,
        value: 0,
        discount_malha: 0,
      },
      // Todas as unidades (as inativas rotulam rotas antigas).
      allUnits: [],
    };
  },
  computed: {
    showUnitsTable() {
      return this.ruleForm.malha && !this.ruleForm.malha_all_units;
    },
    unitList() {
      return this.allUnits.filter((unit) => unit.active);
    },
    activeRoutes() {
      const byId = {};
      for (const unit of this.unitList) byId[unit.id] = unit;
      const routes = [];
      for (const unit of this.unitList) {
        for (const route of unit.malhaRoutes || []) {
          const destiny = byId[route.destinyUnitId];
          if (!destiny) continue;
          routes.push({
            id: route.id,
            sourceId: unit.id,
            sourceCode: unit.code,
            sourceName: unit.name,
            destinyId: destiny.id,
            destinyCode: destiny.code,
            destinyName: destiny.name,
          });
        }
      }
      return routes;
    },
    routableIds() {
      const ids = new Set();
      for (const route of this.activeRoutes) {
        ids.add(route.sourceId);
        ids.add(route.destinyId);
      }
      return ids;
    },
    enabledRoutes() {
      if (this.ruleForm.malha_all_units) return this.activeRoutes;
      const selected = new Set(this.ruleForm.units);
      return this.activeRoutes.filter(
        (route) => selected.has(route.sourceId) && selected.has(route.destinyId)
      );
    },
  },
  watch: {
    showUnitsTable(visible) {
      if (visible) this.applySelection();
    },
    "ruleForm.malha"(enabled) {
      if (!enabled) this.ruleForm.send_all = false;
    },
  },
  async mounted() {
    await this.reloadUnits();
  },
  methods: {
    async reloadUnits() {
      try {
        const response = await UnitService.list();
        this.allUnits = response.records || [];
      } catch (error) {
        this.allUnits = [];
      }
      if (this.showUnitsTable) this.applySelection();
    },
    isRoutable(row) {
      return this.routableIds.has(row.id);
    },
    destinationsOf(row) {
      return this.activeRoutes
        .filter((route) => route.sourceId === row.id)
        .map((route) => route.destinyCode)
        .sort();
    },
    originsOf(row) {
      return this.activeRoutes
        .filter((route) => route.destinyId === row.id)
        .map((route) => route.sourceCode)
        .sort();
    },
    allUnitsChanged(value) {
      if (!value && this.ruleForm.units.length === 0) {
        this.ruleForm.units = this.unitList.filter(this.isRoutable).map((unit) => unit.id);
      }
    },
    applySelection() {
      const vm = this;
      const ids = vm.ruleForm.units.slice();
      vm.$nextTick(() => {
        const table = vm.$refs.tableUnits;
        if (!table) return;
        table.clearSelection();
        for (const row of vm.unitList) {
          if (ids.includes(row.id) && vm.isRoutable(row)) {
            table.toggleRowSelection(row, true);
          }
        }
      });
    },
    onUnitSelectionChange(selection) {
      this.ruleForm.units = selection.map((row) => row.id);
    },
    // Faixa de CEP atendida: início = faixa-origem-raiz/dig, fim = faixa-destino-raiz/dig
    unitRange(unit) {
      const cep = (root, digit) =>
        `${String(root || 0).padStart(5, "0")}-${String(digit || 0).padStart(3, "0")}`;
      return `${cep(unit.sourceRootStart, unit.sourceDigitStart)} à ${cep(
        unit.destinyRootStart,
        unit.destinyDigitStart
      )}`;
    },
    setup(data) {
      this.ruleForm.malha = data.malha;
      this.ruleForm.malha_all_units = data.malhaAllUnits !== false;
      this.ruleForm.send_all = data.malhaSendAll === true;
      this.ruleForm.units = (data.malhaUnits || []).slice();
      this.ruleForm.discount_malha = +data.discount_malha;
      const declared = JSON.parse(data.declared_content);
      if (declared) {
        this.ruleForm.content = declared.content;
        this.ruleForm.quantity = +declared.quantity;
        this.ruleForm.value = +declared.value;
      }
      if (this.showUnitsTable) this.applySelection();
    },
    get() {
      return this.ruleForm;
    },
    validate() {
      const vm = this;
      if (vm.ruleForm.malha) {
        if (!vm.ruleForm.malha_all_units && vm.enabledRoutes.length === 0) {
          return "Selecione unidades que formem ao menos uma rota de malha (origem e destino com rota cadastrada)";
        }
        if (+vm.ruleForm.discount_malha < 0 || vm.ruleForm.discount_malha >= 100) {
          return "Desconto para o cliente não pode ser menor que 0 ou superior a 100%";
        }
        if (!vm.ruleForm.content) {
          return "Conteúdo padrão da declaração de conteudo não pode ser em branco";
        }
        if (+vm.ruleForm.quantity <= 0) {
          return "Quantidade padrão da declaração de conteudo não pode ser 0";
        }
        if (+vm.ruleForm.value <= 0) {
          return "Valor padrão da declaração de conteudo não pode ser 0";
        }
      }
      return "";
    },
  },
};
</script>
<style scoped>
.customer-malha__info {
  margin-left: 4px;
  color: #c0c4cc;
  cursor: help;
}

.customer-malha__muted {
  color: #c0c4cc;
}

.customer-malha__preview {
  margin: 4px 0 18px;
}

.customer-malha__preview-title {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #909399;
}

.customer-malha__route {
  margin: 0 6px 6px 0;
}
</style>
